import { getWebEnvDetails } from "../common/getWebEnvDetails.js";
import { renderAppRoot } from "../common/renderAppRoot.js";
import { sentryInit } from "../common/sentryInit.js";
import { AppraisalReportShared } from "./AppraisalReportShared.js";

sentryInit(getWebEnvDetails());

renderAppRoot(<AppraisalReportShared />);
